<template>
  <v-btn-toggle class="pl-ranges-buttons">
    <v-btn
      v-for="filter in currentFilters"
      :key="filter['.key']"
      @click.native="onViewFilter(filter)"
      :class="{ 'v-btn--active': isCurrentFilter(filter.id) }"
      color="white"
      depressed>
      {{ filter.title }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FilterList',

  computed: {
    ...mapGetters('filters', ['currentFilters'])
  },

  methods: {
    ...mapActions('filters', ['getCurrentFilters']),

    onViewFilter (filter) {
      this.$router.push({
        name: 'ranges_path',
        params: {
          categoryId: filter.categoryId,
          subcategoryId: filter.subcategoryId,
          filterId: filter.id
        }
      })
    },

    isCurrentFilter (id) {
      return id === this.$route.params.filterId
    }
  }
}
</script>
